<template>
  <div class="box">
    <div
      v-if="isStatus"
      class="status-box"
    >
      <div
        v-if="status"
        class='status'
      ></div>
    </div>

    <div
      class="content"
      :class="{skip:isSkip}"
      @click="searchkerword"
    >{{content.name}} {{content.translateName ? `(${content.translateName})` : ''}}</div>

    <div
      class="examine"
      @click="examine"
      v-if="isExamine"
    >搜索</div>
  </div>
</template>

<script>
export default {
  props: {
    tableData: Object,
    scope: Object
  },
  data() {
    return {};
  },
  computed: {
    content() {
      return this.scope.row;
    },
    status() {
      return !this.scope.row[this.tableData.bind]
    },
    isExamine() {
      return this.tableData.distinction === "search";
    },
    isSkip() {
      return this.tableData.distinction === "skip";
    },
    isStatus() {
      return this.tableData.distinction === "status";
    }
  },
  methods: {
    examine() {
      this.tableData.articleAssistant(this.scope.row.name);
    },
    searchkerword() {
      if (!this.tableData.searchkerword) {
        return false;
      }
      let translateName = this.scope.row[this.tableData.bind]
        ? `(${this.scope.row[this.tableData.bind]})`
        : "";

      this.tableData.searchkerword(
        this.scope.row.id,
        this.scope.row.name,
        translateName
      );
    }
  },
  components: {}
};
</script>

<style scoped lang="scss">
.box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: #333;
  padding: 9px 0 8px;
  .status-box {
    height: 23px;
    display: flex;
    align-items: center;
    .status {
      width: 6px;
      height: 6px;
      background-color: #3da1ff;
      border-radius: 50%;
    }
  }
  .content {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: pointer;
  }
  .content.skip {
    color: #54a8fe;
  }
  .examine {
    width: 100px;
    text-align: right;
    color: #54a8fe;
    user-select: none;
    cursor: pointer;
    border: none;
    padding: 0;
  }
}
</style>
